import { connect } from 'react-redux';
import { actions } from "./UserProfileAction";
import PermissionsEditor from './PermissionsEditor';

const mapStateToProps = (state) => {
  const userRoles = state.userProfileReducer.userRoles || {};
  const userProfile = state.userProfileReducer.userProfile || {};
  return {
    userRoles,
    userProfile,
  };
};

export default connect(mapStateToProps, actions)(PermissionsEditor);